import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import Form from "./components/form";
import ProductServices from "../../../services/Product";

const AddStock = () => {

  const route = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const addInventory = async (payload) => {
    setLoading(true)
    try {
      await ProductServices.addInventory(payload)
      SuccessToaster('Inventory Update Successfully')
      navigate(route?.manageStock)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock Management</h4>
              <h6>Add Stock</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={addInventory} loading={loading} />
      </div>
    </div>
  );
};

export default AddStock;
